import Peu from './Peu';
import PeuAmp from './PeuAmp';
import { useAmp } from 'next/amp';

export default function Component(props) {
    const isAmp = useAmp();
    return isAmp ? <PeuAmp {...props} /> : <Peu {...props} />;
}
